import CQr from 'components/qr/Qr'
import CAppbarOld from 'components/appbar-old/Index'
import CAddressSelect from 'components/address-select/Index'
import CMyCalendar from 'components/my-calendar/Index.vue'
import CCalendar from 'components/calendar/Index.vue'
import CProgressBar from 'components/progress-bar/Index.vue'
import CFilter from 'components/filter/Index.vue'
import CNewCheckpoint from 'components/new-checkpoint/Index.vue'
import CCheckpointSheet from 'components/c-checkpoint-sheet/Index.vue'
import CAddVisit from 'components/add-visit/Index.vue'
import CDatePicker from 'components/date-picker/Index.vue'
import CEditVisit from 'components/edit-visit/Index.vue'
import CModal from 'components/modal-message/Index.vue'
import CPagination from 'components/pagination/Index.vue'
import CImporter from 'components/importer/Index.vue'
import CExporter from 'components/exporter/Index.vue'
import CDownload from 'components/download/Index.vue'
import CApplySchedule from 'components/apply-schedule/Index.vue'
import CFireEmployee from 'components/fire-employee/Index.vue'
import CEnbekExtraForm from 'components/enbek-extra-form/Index.vue'
import CKdoModal from 'components/kdo-modal/Index.vue'
import CCreateRole from 'components/create-role/Index.vue'
import CAttachRole from 'components/attach-role/Index.vue'
import CShowVisitOnMap from 'components/show-visit-on-map/Index.vue'
import CShowVisitsOnMap from 'components/show-visit-on-map-by-date/Index.vue'
import CEditBreak from 'components/edit-break/Index.vue'
import CAddBreak from 'components/add-break/Index.vue'
import CRecalcUserSheet from 'components/recalc-user-sheet/Index.vue'
import CSidebar from 'components/sidebar/Index.vue'
import SvgIcon from 'components/SvgIcon/Index.vue'
import CAppbar from 'components/appbar/Index'
import VisitDonutChart from 'components/VisitDonutChart/Index.vue'
import CRadio from 'components/c-radio/Index.vue'
import CCheckbox from 'components/c-checkbox/Index.vue'
import CMonthPicker from 'components/month-picker/Index.vue'
import CTowersGraph from 'components/towers-graph/Index.vue'
import CActions from 'components/c-actions/Index.vue'
import CCalendarInfo from 'components/c-calendar-info/Index.vue'
import CModalSelect from 'components/modal-select/Index.vue'
import CFinesInfo from 'components/fines-info/Index.vue'
import CAttachSettings from 'components/attach-settings/Index.vue'

export default {
  CQr,
  CAppbar,
  CAppbarOld,
  CAddressSelect,
  CMyCalendar,
  CCalendar,
  CProgressBar,
  CFilter,
  CNewCheckpoint,
  CCheckpointSheet,
  CAddVisit,
  CDatePicker,
  CEditVisit,
  CModal,
  CPagination,
  CImporter,
  CExporter,
  CDownload,
  CApplySchedule,
  CFireEmployee,
  CCreateRole,
  CAttachRole,
  CShowVisitOnMap,
  CShowVisitsOnMap,
  CEditBreak,
  CAddBreak,
  CRecalcUserSheet,
  CSidebar,
  SvgIcon,
  VisitDonutChart,
  CRadio,
  CCheckbox,
  CMonthPicker,
  CTowersGraph,
  CActions,
  CCalendarInfo,
  CModalSelect,
  CFinesInfo,
  CEnbekExtraForm,
  CKdoModal,
  CAttachSettings,
}

